// Tool instances by id. Milestones add their tools here (and mark them ready in designUi.ts).
import type { Tool } from './tool';
import type { ToolId } from '../ui/designUi';
import { SelectTool } from './selectTool';
import { ShapeTool } from './shapeTool';
import { EyedropperTool } from './eyedropperTool';
import { TypeTool } from './typeTool';
import { DirectTool } from './directTool';
import { AnchorTool, CurvatureTool, KnifeTool, PenTool, PencilTool, ScissorsTool } from './pathTools';

const tools: Partial<Record<ToolId, Tool>> = {
  select: new SelectTool(),
  rect: new ShapeTool('rect'),
  ellipse: new ShapeTool('ellipse'),
  polygon: new ShapeTool('polygon'),
  star: new ShapeTool('star'),
  line: new ShapeTool('line'),
  eyedropper: new EyedropperTool(),
  type: new TypeTool(),
  direct: new DirectTool(),
  lasso: new DirectTool(true),
  pen: new PenTool(),
  curvature: new CurvatureTool(),
  pencil: new PencilTool(),
  addAnchor: new AnchorTool('add'),
  deleteAnchor: new AnchorTool('delete'),
  convertAnchor: new AnchorTool('convert'),
  scissors: new ScissorsTool(),
  knife: new KnifeTool(),
};

export const toolFor = (id: ToolId): Tool | null => tools[id] ?? null;
export function registerTool(id: ToolId, t: Tool) {
  tools[id] = t;
}
